module.exports = __webpack_public_path__ + "img/sv2.af97ce9c.svg";